import CodeMirror from 'codemirror';

// lifted from CodeMirror and added to. Not sure why it's not exposed in the same
// way as the CSS.
export const javascript = [
  // strings
  'charAt charCodeAt indexOf lastIndexOf substring substr slice trim trimLeft trimRight toUpperCase toLowerCase split concat match replace search',
  // arrays
  'length from concat join splice push pop shift unshift slice reverse sort indexOf lastIndexOf every some filter forEach map reduce reduceRight',
  // objects
  'keys assign entries values',
  // functions
  'prototype apply call bind',
  // keywords
  'break case catch continue debugger default delete do else false finally for function if in instanceof new null return switch throw true try typeof var void while with eval',
  // other stuff
  'Promise class extends let const yield static async await setTimeout clearTimeout setInterval clearInterval requestAnimationFrame cancelAnimationFrame window document getElementById getElementsByTagName querySelector querySelectorAll',
  // bom
  'console log trace resolve reject decodeURIComponent confirm prompt alert encodeURIComponent encodeURI decodeURI escape unescape',
  // handlers
  'onblur onclick onerror onfocus onkeydown onkeypress onkeyup onmouseover onload onmouseup onmousedown onsubmit',
  // thingies
  'Array Date hasOwnProperty Infinity isFinite isNaN isPrototypeOf Math NaN Number Object String toString undefined valueOf',
].reduce((acc, curr) => {
  curr.split(' ').forEach(s => acc.push(s));
  return acc;
}, []);

export const css = CodeMirror.hintWords.css;

export const html = [
  '!DOCTYPE ',
  // 'a',
  'abbr',
  'acronym',
  'address',
  'applet',
  'area',
  'article',
  'aside',
  'audio',
  // 'b',
  'base',
  'basefont',
  'bdi',
  'bdo',
  'big',
  'blockquote',
  'body',
  'br',
  'button',
  'canvas',
  'caption',
  'center',
  'cite',
  'code',
  'col',
  'colgroup',
  'datalist',
  'dd',
  'del',
  'details',
  'dfn',
  'dialog',
  'dir',
  'div',
  'dl',
  'dt',
  'em',
  'embed',
  'fieldset',
  'figcaption',
  'figure',
  'font',
  'footer',
  'form',
  'frame',
  'frameset',
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
  'head',
  'header',
  'hr',
  'html',
  // 'i',
  'iframe',
  'img',
  'input',
  'ins',
  'kbd',
  'keygen',
  'label',
  'legend',
  'li',
  'link',
  'main',
  'map',
  'mark',
  'menu',
  'menuitem',
  'meta',
  'meter',
  'nav',
  'noframes',
  'noscript',
  'object',
  'ol',
  'optgroup',
  'option',
  'output',
  // 'p',
  'param',
  'picture',
  'pre',
  'progress',
  // 'q',
  'rp',
  'rt',
  'ruby',
  // 's',
  'samp',
  'script',
  'section',
  'select',
  'small',
  'source',
  'span',
  'strike',
  'strong',
  'style',
  'sub',
  'summary',
  'sup',
  'table',
  'tbody',
  'td',
  'textarea',
  'tfoot',
  'th',
  'thead',
  'time',
  'title',
  'tr',
  'track',
  'tt',
  // 'u',
  'ul',
  'var',
  'video',
  'wbr',
];



// WEBPACK FOOTER //
// ./src/lib/common/keywords.js